// removed by extract-text-webpack-plugin
module.exports = {"avatarBox":"_2YFKbqB5wrTjbahapmkD2_","avatar":"HOaWfNfSuqY6m3F_cwNqW","group":"_2GpP3nmxUc3ZF18lbDZXB2","bullet":"_1GcnTgRa8qBoYbpnZiWDs1","success":"_3b_qd3RCAs8dRaVCb3xMiy","link":"_2AkEqpbFkrCNN3c0CG7TSN","secondary":"_1VCFlsNqvCvC9gNPMgESYj"};


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/atoms/Avatar/style.css
// module id = 418
// module chunks = 38